export const APP_ROUTER_BASE_NAME = `/ticketfinder${process.env.REACT_APP_APP_ENV}`;
export const APP_ROUTER_CMS_BASE_NAME = `/ticketfinder${process.env.REACT_APP_CMS_API_ENV}`;

const isStaging = process.env.REACT_APP_APP_ENV === "-stag";

export const API_URL = `https://${
  process.env.REACT_APP_API_DEV_ENDPOINT === "true" ? "dev-" : ""
}nationals.fanportal-mlb.com/ticketfinder${process.env.REACT_APP_API_ENV}`;
export const APP_URL =
  process.env.REACT_APP_LOCAL_HOST_CMS === "true"
    ? `http://localhost:8888`
    : `https://nationals.fanportal-mlb.com${APP_ROUTER_CMS_BASE_NAME}`;

export const CMS_ASSET_URL_BASE = `${APP_URL}`;
export const CMS_API_URL_BASE = `${APP_URL}/cms/api/collections/get`;

export const CMS_API_URL_PARAMS = `?populate=nonsense&populate_module=2&token=account-87120a194407aa381d0dc5d4b1b1c1${
  isStaging ? "&previewToken=a1de9dc58e07afec6be4c72808d48e" : ""
}`;

export const CMS = {
  PACKAGE_API_URL: `${CMS_API_URL_BASE}/package${CMS_API_URL_PARAMS}`,
  GAMES_API_URL: `${CMS_API_URL_BASE}/6_SG_Games${CMS_API_URL_PARAMS}`,
  OPPONENT_API_URL: `${CMS_API_URL_BASE}/opponent${CMS_API_URL_PARAMS}`,
  GIVEAWAY_API_URL: `${CMS_API_URL_BASE}/6_1_SG_Games_giveaways${CMS_API_URL_PARAMS}`,
  HOME_BANNER_API_URL: `${CMS_API_URL_BASE}/home_banner${CMS_API_URL_PARAMS}`,
};
